
import { defineComponent, ref, watch, PropType } from 'vue';
import { PlatformLog } from '@/interfaces/panel/platform-logs.model';

export default defineComponent({
  name: 'PlatformLogDetails',
  props: {
    log: {
      type: Object as PropType<PlatformLog | null>,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const isOpen = ref(props.show);

    watch(() => props.show, (newValue) => {
      isOpen.value = newValue;
    });

    const close = () => {
      isOpen.value = false;
      emit('close');
    };

    const getTypeColor = (type: string) => {
      const colors: Record<string, string> = {
        USER_ACTION: 'blue',
        ADMIN_ACTION: 'purple',
        SYSTEM_ACTION: 'grey',
        FINANCIAL: 'green',
        SECURITY: 'red',
      };
      return colors[type] || 'grey';
    };

    const getTypeLabel = (type: string) => {
      const labels: Record<string, string> = {
        USER_ACTION: 'کاربر',
        ADMIN_ACTION: 'ادمین',
        SYSTEM_ACTION: 'سیستم',
        FINANCIAL: 'مالی',
        SECURITY: 'امنیتی',
      };
      return labels[type] || type;
    };

    const getStatusColor = (status: string) => {
      const colors: Record<string, string> = {
        SUCCESS: 'success',
        FAILED: 'error',
        PENDING: 'warning',
      };
      return colors[status] || 'grey';
    };

    const getStatusLabel = (status: string) => {
      const labels: Record<string, string> = {
        SUCCESS: 'موفق',
        FAILED: 'ناموفق',
        PENDING: 'در انتظار',
      };
      return labels[status] || status;
    };

    const formatAmount = (amount: string) => {
      return new Intl.NumberFormat('fa-IR').format(Number(amount));
    };

    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(date);
    };

    return {
      isOpen,
      close,
      getTypeColor,
      getTypeLabel,
      getStatusColor,
      getStatusLabel,
      formatAmount,
      formatDate,
    };
  },
});
